import { Typography } from "@mui/material";
import { styled } from "@mui/system";

export const StyledParagraph = styled(Typography)`
  font-weight: bold;
  font-size: 14px;
`;